module.exports = __webpack_public_path__ + "img/vr.497cdbe4.svg";